import React from 'react';
import PropTypes from 'prop-types';
/* eslint no-unused-vars: [2, { "varsIgnorePattern": "[IconConstants]" }] */
import IconConstants from 'components/shared/icons/IconConstants';
import provideTranslations from 'decorators/provideTranslations';

@provideTranslations('Icons')
class TickIconContainer extends React.Component {
  render() {
    return <TickIcon {...this.props} />;
  }
}

class TickIcon extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    size: PropTypes.number,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static defaultProps = {
    color: IconConstants.DARK_GREY,
    size: 28,
  };

  render() {
    const { getString } = this.context;
    const {
      color,
      size,
    } = this.props;

    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 28 28"
        role="img"
        aria-label={getString('AA_Tick_Icon_Desc')}
      >
        <title>{getString('AA_Tick_Icon_Title')}</title>
        <desc>{getString('AA_Tick_Icon_Desc')}</desc>
        <polygon
          role="presentation"
          stroke="none"
          fill={color}
          fillRule="evenodd"
          transform="translate(13.7, 13.7) rotate(-45) translate(-13.7, -13.7)"
          points="0.5,7.5 0.5,19.9 26.9,19.9 26.9,16.7 3.7,16.7 3.7,7.5"
        />
      </svg>
    );
  }
}

export default TickIconContainer;
